import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {patientDataReducer, PatientEffects} from './store';
import {PatientService} from './services/patient.service';
import {EffectsModule} from '@ngrx/effects';
import {StoreModule} from '@ngrx/store';
import {ClinicalDataComponent} from './clinical-data.component/clinical-data.component';
import {HttpClientModule} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {PatientBackendMockModule} from '@ispm-client/modules/backend-mock-modules/patient-backend-mock';
import {metaReducers} from '@ispm-client/modules/patient/store/reducers/reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('PatientData', patientDataReducer, { metaReducers}),
    HttpClientModule,
    EffectsModule.forFeature([PatientEffects]),
    environment.production ? [] : PatientBackendMockModule.forRoot()
  ],
  providers: [PatientEffects, PatientService],
  declarations: [ClinicalDataComponent],
  exports: [
    ClinicalDataComponent
  ]
})
export class PatientModule { }
